/* Collection Concepts (A + B) — filtering, load more, drawer, card swatches, room hotspots, sliders.
   Vanilla JS, no dependencies. Loaded by every cc-* section; guarded so it only runs once. */
(function () {
  if (window.__ccCollection) return;
  window.__ccCollection = true;

  var state = { drawerOpen: false, drawerTrigger: null, groups: {}, expanded: {}, controller: null };

  /* ---------- helpers ---------- */
  function viewParam() { return new URLSearchParams(location.search).get('view'); }
  function withView(url) {
    var u = new URL(url, location.origin);
    var v = viewParam();
    if (v && !u.searchParams.has('view')) u.searchParams.set('view', v);
    return u;
  }
  function liveRegion() {
    var el = document.getElementById('cc-live');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cc-live';
      el.className = 'visually-hidden';
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
      document.body.appendChild(el);
    }
    return el;
  }
  function announce(msg) {
    var el = liveRegion();
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 60);
  }
  function refreshIds() {
    var ids = [];
    document.querySelectorAll('[data-cc-refresh]').forEach(function (el) {
      if (ids.indexOf(el.dataset.ccRefresh) === -1) ids.push(el.dataset.ccRefresh);
    });
    return ids.slice(0, 5); // Section Rendering API limit
  }
  /* Height of any fixed/sticky site header currently covering the top of the screen. */
  var ccHdrs = null;
  function ccTopOffset() {
    if (!ccHdrs) ccHdrs = Array.prototype.slice.call(document.querySelectorAll('header, .site-header, [id*="header" i], [class*="header-wrapper" i], [class*="sticky-header" i]'));
    var off = 0;
    ccHdrs.forEach(function (e) {
      if (e.closest('[data-cc-grid]')) return;
      var c = getComputedStyle(e);
      if (c.position !== 'fixed' && c.position !== 'sticky') return;
      var r = e.getBoundingClientRect();
      if (r.height > 0 && r.top <= 1 && r.bottom > off && r.bottom < window.innerHeight / 2 && r.width > window.innerWidth / 2) off = r.bottom;
    });
    return Math.round(off);
  }
  /* Desktop scale: #MainContent may be zoomed; sticky "top" values inside it are scaled, so divide screen px by the zoom. */
  function ccZoom() {
    var m = document.getElementById('MainContent');
    var z = m ? parseFloat(getComputedStyle(m).zoom) : 1;
    return z > 0 && z <= 1 ? z : 1;
  }
  function ccStickyTop() {
    var hdr = ccTopOffset(), extra = 16, root = document.documentElement.style, z = ccZoom();
    var bar = document.querySelector('.cc-stickybar .cc-toolbar');
    // Everything sticky on the collection page sits under the site's own sticky header (phones' Filter & sort bar too).
    root.setProperty('--cc-bar-top', (hdr / z) + 'px');
    var mbar = document.querySelector('[data-cc-mbar]');
    if (mbar && window.innerWidth < 990) mbar.classList.toggle('is-stuck', mbar.getBoundingClientRect().top <= hdr + 1); // mbar.is-stuck
    if (bar && window.innerWidth >= 990) {
      // Floating toolbar sits under the site header; the sticky sidebar sits under the toolbar.
      extra = bar.getBoundingClientRect().height + 12 * z;
      bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= hdr + 1);
    }
    root.setProperty('--cc-sticky-top', ((hdr + extra) / z) + 'px');
    root.setProperty('--cc-side-max', Math.max(240, (window.innerHeight - hdr - extra - 16) / z) + 'px');
  }
  /* After filtering / sorting: if the shopper is below the top of the results, bring them back to it. */
  function ccScrollToResults() {
    if (state.drawerOpen) { state.scrollAfterClose = true; return; }
    var g = document.querySelector('[data-cc-grid]');
    if (!g) return;
    var off = ccTopOffset() + 12;
    var top = g.getBoundingClientRect().top;
    if (top >= off) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: window.scrollY + top - off, behavior: reduce ? 'auto' : 'smooth' });
  }
  function locOf(el) { return el.closest('[data-cc-drawer]') ? 'drawer' : 'page'; }

  /* Remember which filter groups are open / expanded so a refresh doesn't collapse them */
  function snapshot() {
    document.querySelectorAll('details[data-cc-group]').forEach(function (d) {
      state.groups[locOf(d) + '|' + d.dataset.ccGroup] = d.open;
    });
  }
  function restore() {
    document.querySelectorAll('details[data-cc-group]').forEach(function (d) {
      var key = locOf(d) + '|' + d.dataset.ccGroup;
      if (key in state.groups && d.querySelector('input:checked') === null) d.open = state.groups[key];
      if (state.expanded[key]) {
        d.classList.add('is-expanded');
        var t = d.querySelector('[data-cc-more-toggle]');
        if (t) { t.setAttribute('aria-expanded', 'true'); t.dataset.more = t.dataset.more || t.textContent; t.textContent = t.dataset.less; }
      }
    });
  }

  /* ---------- filter / sort navigation ---------- */
  function navigate(url, push) {
    var u = withView(url);
    u.searchParams.delete('page');
    var ids = refreshIds();
    if (!ids.length) { location.href = u.toString(); return; }
    var fetchUrl = new URL(u.toString());
    fetchUrl.searchParams.set('sections', ids.join(','));

    if (state.controller) state.controller.abort();
    state.controller = 'AbortController' in window ? new AbortController() : null;
    document.querySelectorAll('.cc-main').forEach(function (m) { m.classList.add('is-loading'); });

    var active = document.activeElement;
    var focusKey = null;
    if (active && active.name && active.closest('[data-cc-filter-form], [data-cc-sort]')) {
      focusKey = { name: active.name, value: active.value, loc: locOf(active) };
    } else if (active && active.hasAttribute && active.hasAttribute('data-cc-sort')) {
      focusKey = { sort: true, loc: locOf(active) };
    }

    fetch(fetchUrl.toString(), { signal: state.controller ? state.controller.signal : undefined, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (json) {
        snapshot();
        ids.forEach(function (id) {
          if (!json[id]) return;
          var doc = new DOMParser().parseFromString(json[id], 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id);
          var cur = document.getElementById('shopify-section-' + id);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        restore();
        state.autoCount = 0;
        state.morePage = 0;
        ccAutoWatch();
        initSliders(document);
        if (state.drawerOpen) {
          var dr = document.querySelector('[data-cc-drawer]');
          if (dr) { dr.classList.add('is-refreshing'); dr.hidden = false; }
        }
        if (push !== false) history.pushState({ cc: true }, '', u.pathname + u.search);
        ccScrollToResults();
        var count = document.querySelector('[data-cc-count]');
        if (count) announce(count.textContent.replace(/\s+/g, ' ').trim());
        if (focusKey) {
          var sel = focusKey.sort ? '[data-cc-sort]' : '[name="' + CSS.escape(focusKey.name) + '"][value="' + CSS.escape(focusKey.value) + '"]';
          var candidates = document.querySelectorAll(sel);
          for (var i = 0; i < candidates.length; i++) {
            if (locOf(candidates[i]) === focusKey.loc) { candidates[i].focus({ preventScroll: true }); break; }
          }
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        location.href = u.toString(); // graceful fallback: full page load
      });
  }

  function submitForm(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var base = form.getAttribute('action') || location.pathname;
    navigate(base + (params.toString() ? '?' + params.toString() : ''));
  }

  /* ---------- load more ---------- */
  function pageOf(href) { var p = parseInt(new URL(href, location.origin).searchParams.get('page'), 10); return p > 0 ? p : 1; }
  function loadMore(btn, quiet) {
    var grid = btn.closest('[data-cc-grid]');
    if (!grid) { location.href = btn.href; return Promise.resolve(); }
    if (state.moreBusy) return state.moreBusy;
    var page = pageOf(btn.href);
    var id = grid.dataset.ccGrid;
    var u = withView(btn.href);
    u.searchParams.set('section_id', id);
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    state.moreBusy = fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        state.morePage = page;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = grid.querySelector('[data-cc-items]');
        var items = doc.querySelectorAll('[data-cc-items] > [data-cc-item]');
        var first = null;
        items.forEach(function (it) {
          var node = document.importNode(it, true);
          list.appendChild(node);
          if (!first) first = node;
        });
        var freshMore = doc.querySelector('[data-cc-more-wrap]');
        var curMore = grid.querySelector('[data-cc-more-wrap]');
        if (freshMore && curMore) curMore.replaceWith(document.importNode(freshMore, true));
        var status = grid.querySelector('[data-cc-shown]');
        if (status) announce(status.textContent.trim());
        if (ccPhotoGrid()) ccApplyPhoto(ccPhotoMode());
        if (first && !quiet) {
          var link = first.querySelector('.cc-card__title');
          if (link) link.focus({ preventScroll: true });
        }
      })
      .catch(function () { location.href = btn.href; })
      .then(function () { state.moreBusy = null; });
    return state.moreBusy;
  }

  /* Auto-load on scroll (grid setting auto_load): up to data-cc-autoload loads per listing, then the button returns. */
  state.autoCount = 0;
  // Checked on scroll (rAF-throttled), looking the button up fresh each time so re-rendered buttons and fast flicks are caught.
  function ccAutoWatch() {
    if (state.restoring || state.moreBusy) return;
    var grid = document.querySelector('[data-cc-grid][data-cc-autoload]');
    if (!grid) return;
    var cap = parseInt(grid.dataset.ccAutoload, 10) || 0;
    if (state.autoCount >= cap) return;
    var btn = grid.querySelector('[data-cc-loadmore]');
    if (!btn || btn.getBoundingClientRect().top > window.innerHeight + 700) return;
    state.autoCount++;
    loadMore(btn, true);
  }
  var ccAutoTick = false;
  window.addEventListener('scroll', function () {
    if (ccAutoTick) return;
    ccAutoTick = true;
    requestAnimationFrame(function () { ccAutoTick = false; ccAutoWatch(); if (document.querySelector('.cc-layout--sticky, .cc-stickybar, .cc-mbar')) ccStickyTop(); });
  }, { passive: true });
  window.addEventListener('resize', function () { if (document.querySelector('.cc-layout--sticky, .cc-stickybar, .cc-mbar')) ccStickyTop(); });

  /* Back-button fix: remember how many pages were loaded + the scroll position, and rebuild them on return. */
  function ccBackKey() { var u = new URL(location.href); u.searchParams.delete('page'); return u.pathname + u.search; }
  var ccBackAnchor = null; // the card the shopper opened: index in the grid + its offset from the top of the screen
  function ccBackSave() {
    if (!document.querySelector('[data-cc-grid]')) return;
    try {
      sessionStorage.setItem('ccBack', JSON.stringify({ key: ccBackKey(), page: state.morePage || pageOf(location.href), y: Math.round(window.scrollY),
        anchor: ccBackAnchor, auto: state.autoCount, t: Date.now() }));
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cc-items] a[href]');
    if (!a) return;
    var item = a.closest('[data-cc-item]');
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-cc-items] > [data-cc-item]'));
    ccBackAnchor = item ? { i: items.indexOf(item), top: Math.round(item.getBoundingClientRect().top) } : null;
    ccBackSave();
  }, true);
  window.addEventListener('pagehide', function () { if (!ccBackAnchor) ccBackSave(); });
  function ccBackScroll(saved) {
    var items = document.querySelectorAll('[data-cc-items] > [data-cc-item]');
    var it = saved.anchor && saved.anchor.i >= 0 ? items[saved.anchor.i] : null;
    if (it) window.scrollTo(0, window.scrollY + it.getBoundingClientRect().top - saved.anchor.top);
    else window.scrollTo(0, saved.y);
  }
  function ccBackRestore() {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('ccBack') || 'null'); } catch (e) {}
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!saved || !nav || nav.type !== 'back_forward' || saved.key !== ccBackKey() || Date.now() - saved.t > 3600000) return;
    var start = pageOf(location.href);
    state.autoCount = saved.auto || 0;
    if (!(saved.page > start)) return; // nothing extra was loaded: the browser's own scroll restore is enough
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    state.restoring = true;
    var step = function () {
      var btn = document.querySelector('[data-cc-grid] [data-cc-loadmore]');
      if (!btn || (state.morePage || start) >= saved.page) {
        state.restoring = false;
        ccBackScroll(saved);
        setTimeout(function () { ccBackScroll(saved); }, 400); // again once images above have settled
        ccAutoWatch();
        return;
      }
      loadMore(btn, true).then(step);
    };
    step();
  }
  var ccMoreInit = function () { ccBackRestore(); ccAutoWatch(); if (document.querySelector('.cc-layout--sticky, .cc-stickybar, .cc-mbar')) ccStickyTop(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ccMoreInit); else ccMoreInit();

  /* ---------- drawer ---------- */
  function openDrawer(trigger) {
    var grid = trigger.closest('[data-cc-grid]') || document;
    var drawer = grid.querySelector('[data-cc-drawer]') || document.querySelector('[data-cc-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-refreshing');
    drawer.hidden = false;
    state.drawerOpen = true;
    state.drawerTrigger = trigger;
    document.documentElement.classList.add('cc-lock');
    document.querySelectorAll('[data-cc-drawer-open][aria-controls]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var group = trigger.dataset.ccDrawerGroup;
    if (group) {
      var d = drawer.querySelector('details[data-cc-group="' + CSS.escape(group) + '"]');
      if (d) { d.open = true; setTimeout(function () { d.scrollIntoView({ block: 'start' }); var s = d.querySelector('summary'); if (s) s.focus(); }, 30); return; }
    }
    var x = drawer.querySelector('.cc-drawer__x');
    if (x) x.focus();
  }
  function closeDrawer() {
    var drawer = document.querySelector('[data-cc-drawer]:not([hidden])');
    if (drawer) drawer.hidden = true;
    state.drawerOpen = false;
    document.documentElement.classList.remove('cc-lock');
    document.querySelectorAll('[data-cc-drawer-open][aria-controls]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var t = document.querySelector('.cc-mbar__btn');
    if (t) t.focus({ preventScroll: true });
    if (state.scrollAfterClose) { state.scrollAfterClose = false; ccScrollToResults(); }
  }
  function trapFocus(e) {
    var drawer = document.querySelector('[data-cc-drawer]:not([hidden])');
    if (!drawer) return;
    var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, select, summary');
    var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!vis.length) return;
    var firstEl = vis[0], lastEl = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
  }

  /* ---------- room hotspots ---------- */
  function closePops(except) {
    document.querySelectorAll('[data-cc-hotspot][aria-expanded="true"]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
  }
  function toggleHotspot(btn) {
    var pop = document.getElementById(btn.getAttribute('aria-controls'));
    if (!pop) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    closePops(btn);
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    pop.hidden = open;
    var root = btn.closest('[data-cc-rooms]');
    if (root) {
      root.querySelectorAll('[data-cc-room-line]').forEach(function (l) {
        l.classList.toggle('is-active', !open && l.dataset.ccRoomLine === btn.dataset.ccHotspot);
      });
    }
  }
  function showRoom(root, idx) {
    var rooms = root.querySelectorAll('[data-cc-room]');
    var n = 0;
    rooms.forEach(function (r) { n = Math.max(n, parseInt(r.dataset.ccRoom, 10) + 1); });
    if (!n) return;
    idx = ((idx % n) + n) % n;
    closePops();
    rooms.forEach(function (r) { r.hidden = parseInt(r.dataset.ccRoom, 10) !== idx; });
    root.dataset.ccCurrent = idx;
    var label = root.querySelector('[data-cc-room-count]');
    if (label) label.textContent = (idx + 1) + ' / ' + n;
    announce('Room ' + (idx + 1) + ' of ' + n);
  }

  /* ---------- card photo slider: dots + arrow state ---------- */
  function syncCard(track, i) {
    var media = track.parentNode;
    media.querySelectorAll('.cc-card__dot').forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    var pv = media.querySelector('[data-cc-img-prev]');
    var nx = media.querySelector('[data-cc-img-next]');
    if (pv) pv.disabled = i <= 0;
    if (nx) nx.disabled = i >= track.children.length - 1;
  }

  /* ---------- sliders (mobile arrows) ---------- */
  function updateArrows(track) {
    var wrap = track.closest('.cc-carousel');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-cc-prev]');
    var next = wrap.querySelector('[data-cc-next]');
    if (prev) prev.disabled = track.scrollLeft <= 4;
    if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
  }
  function initSliders(root) {
    (root || document).querySelectorAll('[data-cc-track]').forEach(updateArrows);
  }
  function slide(btn, dir) {
    var wrap = btn.closest('.cc-carousel');
    var track = wrap && wrap.querySelector('[data-cc-track]');
    if (!track) return;
    var kids = track.children;
    var pitch = kids.length > 1 ? kids[1].offsetLeft - kids[0].offsetLeft : track.clientWidth * 0.8;
    track.scrollBy({ left: dir * pitch, behavior: 'smooth' });
  }

  /* ---------- events ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    var form = t.closest && t.closest('[data-cc-filter-form]');
    if (form) { submitForm(form); return; }
    if (t.matches && t.matches('[data-cc-sort]')) {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', t.value);
      navigate(u.toString());
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-cc-filter-form]');
    if (form) { e.preventDefault(); submitForm(form); }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var a = t.closest('a[data-cc-link]');
    if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault();
      navigate(a.href);
      return;
    }
    var more = t.closest('[data-cc-loadmore]');
    if (more && !e.metaKey && !e.ctrlKey) { e.preventDefault(); loadMore(more); return; }

    var open = t.closest('[data-cc-drawer-open]');
    if (open) { e.preventDefault(); openDrawer(open); return; }
    if (t.closest('[data-cc-drawer-close]')) { closeDrawer(); return; }

    var tog = t.closest('[data-cc-more-toggle]');
    if (tog) {
      var g = tog.closest('.cc-fgroup');
      var ex = g.classList.toggle('is-expanded');
      tog.setAttribute('aria-expanded', ex ? 'true' : 'false');
      if (!tog.dataset.more) tog.dataset.more = tog.textContent;
      tog.textContent = ex ? tog.dataset.less : tog.dataset.more;
      state.expanded[locOf(g) + '|' + g.dataset.ccGroup] = ex;
      return;
    }

    var sw = t.closest('[data-cc-swatch]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('[data-cc-card]');
      var on = sw.getAttribute('aria-pressed') !== 'true';
      card.querySelectorAll('[data-cc-swatch]').forEach(function (b) { b.setAttribute('aria-pressed', b === sw && on ? 'true' : 'false'); });
      ccSwatchShow(card, on ? sw : null, true);
      // Point the card's links at the chosen finish, so the product page opens on it.
      card.querySelectorAll('.cc-card__title, [data-cc-slides]').forEach(function (a) {
        if (!a.dataset.baseHref) a.dataset.baseHref = a.getAttribute('href');
        a.setAttribute('href', on && sw.dataset.href ? sw.dataset.href : a.dataset.baseHref);
      });
      return;
    }

    var hs = t.closest('[data-cc-hotspot]');
    if (hs) { e.preventDefault(); toggleHotspot(hs); return; }
    var pclose = t.closest('[data-cc-pop-close]');
    if (pclose) { closePops(); return; }
    if (!t.closest('[data-cc-pop]')) closePops();

    var rn = t.closest('[data-cc-room-next], [data-cc-room-prev]');
    if (rn) {
      var root = rn.closest('[data-cc-rooms]');
      var cur = parseInt(root.dataset.ccCurrent || '0', 10);
      showRoom(root, cur + (rn.hasAttribute('data-cc-room-prev') ? -1 : 1));
      return;
    }

    var imgNav = t.closest('[data-cc-img-prev], [data-cc-img-next]');
    if (imgNav) {
      e.preventDefault();
      var track = imgNav.closest('.cc-card__media').querySelector('[data-cc-slides]');
      if (track) {
        var w = Math.max(1, track.clientWidth);
        var idx = Math.round(track.scrollLeft / w) + (imgNav.hasAttribute('data-cc-img-prev') ? -1 : 1);
        idx = Math.max(0, Math.min(track.children.length - 1, idx));
        var target = idx * w;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
        setTimeout(function () {
          if (Math.abs(track.scrollLeft - target) > 2) { track.style.scrollBehavior = 'auto'; track.scrollLeft = target; track.style.scrollBehavior = ''; }
        }, 500);
        syncCard(track, idx);
      }
      return;
    }

    var p = t.closest('[data-cc-prev]');
    if (p) { slide(p, -1); return; }
    var n = t.closest('[data-cc-next]');
    if (n) { slide(n, 1); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (state.drawerOpen) { closeDrawer(); return; }
      var openHs = document.querySelector('[data-cc-hotspot][aria-expanded="true"]');
      if (openHs) { closePops(); openHs.focus(); }
    }
    if (e.key === 'Tab' && state.drawerOpen) trapFocus(e);
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-cc-slides]')) {
      syncCard(t, Math.round(t.scrollLeft / Math.max(1, t.clientWidth)));
    } else if (t.matches('[data-cc-track]')) {
      updateArrows(t);
    }
  }, true);

  window.addEventListener('popstate', function () {
    if (document.querySelector('[data-cc-grid]')) navigate(location.href, false);
  });

  function boot() { initSliders(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
  window.addEventListener('resize', function () { initSliders(document); });

  /* Option swatches on cards: show a finish's photo (preview on hover, keep on click). */
  function ccSwatchShow(card, sw, keep) {
    var img = card.querySelector('.cc-card__slide img');
    if (!img) return;
    if (!img.dataset.origSrc) { img.dataset.origSrc = img.currentSrc || img.src; img.dataset.origSrcset = img.getAttribute('srcset') || ''; }
    var src = sw && sw.dataset.src, srcset = sw && sw.dataset.srcset;
    if (!src) { var sel = card.querySelector('[data-cc-swatch][aria-pressed="true"]'); if (!keep && sel && sel.dataset.src) { src = sel.dataset.src; srcset = sel.dataset.srcset; } }
    img.srcset = src ? (srcset || '') : img.dataset.origSrcset;
    img.src = src || img.dataset.origSrc;
    var slides = card.querySelector('[data-cc-slides]');
    if (slides) slides.scrollLeft = 0;
  }
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest && e.target.closest('[data-cc-swatch]');
      if (sw && sw.dataset.src) ccSwatchShow(sw.closest('[data-cc-card]'), sw, false);
    });
    document.addEventListener('mouseout', function (e) {
      var sw = e.target.closest && e.target.closest('[data-cc-swatch]');
      if (!sw || (e.relatedTarget && sw.contains(e.relatedTarget))) return;
      var card = sw.closest('[data-cc-card]');
      ccSwatchShow(card, card.querySelector('[data-cc-swatch][aria-pressed="true"]'), false);
    });
  }

  /* Card option design compare: ?cards=a|b|c applies that design and shows a small A/B/C switch. */
  (function () {
    var q = (new URLSearchParams(window.location.search).get('cards') || '').toLowerCase();
    if (!/^[abc]$/.test(q)) return;
    function apply(v) {
      document.querySelectorAll('[data-cc-optstyle]').forEach(function (g) {
        g.classList.remove('cc-optstyle-a', 'cc-optstyle-b', 'cc-optstyle-c');
        g.classList.add('cc-optstyle-' + v);
      });
      bar.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.v === v ? 'true' : 'false'); });
      var u = new URL(window.location.href); u.searchParams.set('cards', v); history.replaceState({}, '', u);
    }
    var bar = document.createElement('div');
    bar.className = 'cc-optswitch';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Compare card designs');
    bar.innerHTML = '<span>Card design</span>' + ['a', 'b', 'c'].map(function (v) {
      return '<button type="button" data-v="' + v + '">' + v.toUpperCase() + '</button>';
    }).join('');
    bar.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) apply(b.dataset.v); });
    var go = function () { document.body.appendChild(bar); apply(q); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
    document.addEventListener('shopify:section:load', function () { apply(bar.querySelector('[aria-pressed="true"]').dataset.v); });
  })();

  /* Filter pre-selection: a swatch matching an active option filter starts selected, its photo shows
     and the card links to that variant. Runs on load and whenever the grid is re-rendered. */
  function ccApplyPreselect(root) {
    (root || document).querySelectorAll('[data-cc-swatch][data-cc-preselect]').forEach(function (sw) {
      var card = sw.closest('[data-cc-card]');
      if (!card || card.dataset.ccPre === '1') return;
      card.dataset.ccPre = '1';
      if (sw.dataset.src) ccSwatchShow(card, sw, true);
      card.querySelectorAll('.cc-card__title, [data-cc-slides]').forEach(function (a) {
        if (!a.dataset.baseHref) a.dataset.baseHref = a.getAttribute('href');
        if (sw.dataset.href) a.setAttribute('href', sw.dataset.href);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ccApplyPreselect(); });
  else ccApplyPreselect();
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function () { ccApplyPreselect(); }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Room / Product photo switch (grid setting show_room_toggle): flips every card to its room photo. */
  function ccApplyPhoto(mode) {
    document.querySelectorAll('[data-cc-items]').forEach(function (g) {
      g.classList.toggle('cc-grid--room', mode === 'room');
      g.classList.toggle('cc-grid--mixed', mode === 'mixed');
      // Swap each card's first photo for its room shot (data-cc-room-src), and back.
      g.querySelectorAll('[data-cc-card][data-cc-room-src]').forEach(function (card) {
        var img = card.querySelector('.cc-card__slide img');
        if (!img) return;
        if (!img.dataset.prodSrc) {
          // Room-first pages render the room photo first; the product photo comes from data-cc-prod-src.
          img.dataset.prodSrc = card.dataset.ccProdSrc || img.getAttribute('src');
          img.dataset.prodSrcset = card.dataset.ccProdSrcset || img.getAttribute('srcset') || '';
        }
        var room = mode === 'room' || (mode === 'mixed' && card.hasAttribute('data-cc-mix'));
        img.setAttribute('srcset', room ? card.dataset.ccRoomSrcset : img.dataset.prodSrcset);
        img.setAttribute('src', room ? card.dataset.ccRoomSrc : img.dataset.prodSrc);
        img.closest('.cc-card__slide').classList.toggle('is-room-shot', room);
      });
    });
    document.querySelectorAll('[data-cc-photo]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.ccPhoto === mode ? 'true' : 'false'); });
  }
  // Remembered per collection (sessionStorage "ccPhoto:<handle>"); otherwise the collection's default.
  function ccPhotoGrid() { return document.querySelector('[data-cc-items][data-cc-photo-default]'); }
  function ccPhotoKey() { var g = ccPhotoGrid(); return 'ccPhoto:' + ((g && g.dataset.ccPhotoKey) || location.pathname); }
  function ccPhotoMode() {
    var g = ccPhotoGrid(), d = (g && g.dataset.ccPhotoDefault) || 'product';
    try { return sessionStorage.getItem(ccPhotoKey()) || d; } catch (e) { return d; }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cc-photo]');
    if (!b) return;
    e.preventDefault();
    try { sessionStorage.setItem(ccPhotoKey(), b.dataset.ccPhoto); } catch (err) {}
    ccApplyPhoto(b.dataset.ccPhoto);
  });
  var ccPhotoInit = function () {
    var g = ccPhotoGrid();
    if (!g) return;
    var mode = ccPhotoMode();
    // The server already rendered the default view; only switch when the shopper chose otherwise.
    if (mode !== (g.dataset.ccPhotoDefault || 'product') || document.querySelector('[data-cc-photo]')) ccApplyPhoto(mode);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ccPhotoInit); else ccPhotoInit();
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function () {
      var g = document.querySelector('[data-cc-items]');
      if (!g || !g.hasAttribute('data-cc-photo-default')) return;
      var pm = ccPhotoMode();
      if (g.classList.contains('cc-grid--room') !== (pm === 'room') || g.classList.contains('cc-grid--mixed') !== (pm === 'mixed')) ccApplyPhoto(pm);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Hide / Show filters (grid setting show_filter_toggle). Remembered while browsing (sessionStorage ccFilters). */
  function ccFiltersPref(layout) {
    var d = (layout && layout.dataset.ccFiltersStart) || 'shown';
    try { return sessionStorage.getItem('ccFilters') || d; } catch (e) { return d; }
  }
  function ccApplyFilters(state) {
    document.querySelectorAll('[data-cc-filters-layout]').forEach(function (l) { l.classList.toggle('cc-layout--collapsed', state === 'hidden'); });
    document.querySelectorAll('[data-cc-filtertoggle]').forEach(function (b) {
      var shown = state !== 'hidden';
      b.setAttribute('aria-expanded', shown ? 'true' : 'false');
      var lbl = b.querySelector('[data-cc-ft-label]');
      if (lbl) lbl.textContent = shown ? b.dataset.labelHide : b.dataset.labelShow;
      b.classList.toggle('is-nudge', !ccFiltersSeen());
    });
  }
  function ccFiltersSeen() { try { return localStorage.getItem('ccFiltersSeen') === '1'; } catch (e) { return true; } }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cc-filtertoggle]');
    if (!b) return;
    e.preventDefault();
    var next = b.getAttribute('aria-expanded') === 'true' ? 'hidden' : 'shown';
    // From the floating toolbar with a non-sticky sidebar: open the slide-out filter panel instead (no jump to the top).
    if (next === 'shown' && b.closest('.cc-toolbar.is-stuck') && !document.querySelector('.cc-layout--sticky') && document.querySelector('[data-cc-drawer]')) {
      try { localStorage.setItem('ccFiltersSeen', '1'); } catch (err) {}
      openDrawer(b);
      return;
    }
    try { sessionStorage.setItem('ccFilters', next); if (next === 'shown') localStorage.setItem('ccFiltersSeen', '1'); } catch (err) {}
    ccApplyFilters(next);
  });
  var ccFiltersInit = function () {
    var l = document.querySelector('[data-cc-filters-layout]');
    if (l) ccApplyFilters(ccFiltersPref(l));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ccFiltersInit); else ccFiltersInit();
  if (typeof MutationObserver === 'function') {
    // Filtering re-renders the grid section: keep the shopper's choice.
    new MutationObserver(function () {
      var l = document.querySelector('[data-cc-filters-layout]');
      var b = document.querySelector('[data-cc-filtertoggle]');
      if (l && (l.classList.contains('cc-layout--collapsed') !== (ccFiltersPref(l) === 'hidden') || (b && !b.dataset.ccFt))) {
        if (b) b.dataset.ccFt = '1';
        ccApplyFilters(ccFiltersPref(l));
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Promoted filters, phone layout "Group tabs": one tab per group, one row of options at a time. */
  var ccPfActive = 0;
  function ccPfSet(pf, idx) {
    pf.querySelectorAll('.cc-pf__group').forEach(function (g, i) { g.classList.toggle('is-active', i === idx); });
    pf.querySelectorAll('.cc-pf__tab').forEach(function (b, i) { b.setAttribute('aria-pressed', i === idx ? 'true' : 'false'); });
  }
  function ccPfTabs() {
    document.querySelectorAll('.cc-promo-filters--m-tabs .cc-pf').forEach(function (pf) {
      if (pf.querySelector('.cc-pf__tabs')) return;
      var groups = pf.querySelectorAll('.cc-pf__group');
      if (groups.length < 2) return;
      var bar = document.createElement('div');
      bar.className = 'cc-pf__tabs';
      groups.forEach(function (g, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-pf__tab';
        b.dataset.ccPfTab = i;
        var t = g.querySelector('.cc-pf__title');
        b.textContent = t ? t.textContent.trim() : 'Filter';
        if (g.querySelector('.cc-pill.is-active, .cc-pill[aria-current], .cc-pill[aria-pressed="true"]')) {
          var dot = document.createElement('span'); dot.className = 'cc-pf__tab-dot'; dot.setAttribute('aria-hidden', 'true'); b.appendChild(dot);
        }
        bar.appendChild(b);
      });
      pf.insertBefore(bar, pf.firstChild);
      pf.classList.add('cc-pf--tabbed');
      ccPfSet(pf, Math.min(ccPfActive, groups.length - 1));
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cc-pf-tab]');
    if (!b) return;
    ccPfActive = +b.dataset.ccPfTab;
    ccPfSet(b.closest('.cc-pf'), ccPfActive);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ccPfTabs); else ccPfTabs();
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function () { if (document.querySelector('.cc-promo-filters--m-tabs .cc-pf:not(.cc-pf--tabbed)')) ccPfTabs(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Card photo swipe: keep the dots in step with the visible photo. */
  var ccDotsTick = null;
  function ccDotsSync(strip) {
    var media = strip.closest('.cc-card__media');
    var dots = media && media.querySelectorAll('.cc-card__dot');
    if (!dots || !dots.length || !strip.clientWidth) return;
    var i = Math.round(strip.scrollLeft / strip.clientWidth);
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-cc-slides]')) return;
    if (ccDotsTick) cancelAnimationFrame(ccDotsTick);
    ccDotsTick = requestAnimationFrame(function () { ccDotsSync(t); });
  }, true);

  /* Floating toolbar: one dropdown per promoted-filter group, built from the promoted filters section's own pills
     (same links, so picking one filters like the pills do). Rebuilt whenever the toolbar is re-rendered. */
  function ccBarDrops() {
    var bar = document.querySelector('.cc-stickybar .cc-toolbar');
    var pf = document.querySelector('.cc-promo-filters .cc-pf');
    if (!bar || !pf || bar.querySelector('[data-cc-bardrops]')) return;
    var groups = pf.querySelectorAll('.cc-pf__group');
    if (!groups.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'cc-bardrops';
    wrap.setAttribute('data-cc-bardrops', '');
    groups.forEach(function (g, i) {
      var t = g.querySelector('.cc-pf__title');
      var pills = g.querySelectorAll('.cc-pill');
      if (!pills.length) return;
      var dd = document.createElement('div');
      dd.className = 'cc-bardrop';
      var id = 'cc-bardrop-' + i;
      var active = g.querySelectorAll('.cc-pill.is-active').length;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cc-bardrop__btn' + (active ? ' is-active' : '');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', id);
      btn.setAttribute('data-cc-bardrop', '');
      btn.innerHTML = '<span></span>' + (active ? '<span class="cc-bardrop__n">' + active + '</span>' : '') +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
      btn.firstChild.textContent = t ? t.textContent.trim() : 'Filter';
      var menu = document.createElement('div');
      menu.className = 'cc-bardrop__menu';
      menu.id = id;
      menu.hidden = true;
      pills.forEach(function (p) { menu.appendChild(p.cloneNode(true)); });
      dd.appendChild(btn);
      dd.appendChild(menu);
      wrap.appendChild(dd);
    });
    var anchor = bar.querySelector('.cc-phototoggle') || bar.querySelector('[data-cc-filtertoggle]') || bar.querySelector('[data-cc-count]');
    if (anchor) anchor.insertAdjacentElement('afterend', wrap); else bar.appendChild(wrap);
  }
  function ccBarDropsClose(except) {
    document.querySelectorAll('[data-cc-bardrop][aria-expanded="true"]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var m = document.getElementById(b.getAttribute('aria-controls'));
      if (m) m.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cc-bardrop]');
    if (b) {
      var open = b.getAttribute('aria-expanded') !== 'true';
      ccBarDropsClose(b);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      var m = document.getElementById(b.getAttribute('aria-controls'));
      if (m) m.hidden = !open;
      return;
    }
    if (!(e.target.closest && e.target.closest('.cc-bardrop__menu'))) ccBarDropsClose();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') ccBarDropsClose(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ccBarDrops); else ccBarDrops();
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function () {
      if (document.querySelector('.cc-stickybar .cc-toolbar:not(:has([data-cc-bardrops]))')) ccBarDrops();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Phone bar "inline" mode: a chip opens its options in a row right under the bar (phones only; tablets keep the panel). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cc-mbar-toggle]');
    if (!b || window.innerWidth >= 750) return;
    e.preventDefault();
    e.stopPropagation(); // keep the slide-out panel closed
    var open = b.getAttribute('aria-expanded') !== 'true';
    var bar = b.closest('[data-cc-mbar]');
    bar.querySelectorAll('[data-cc-mbar-toggle]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
    bar.querySelectorAll('[data-cc-mbar-opts]').forEach(function (o) { o.hidden = true; });
    if (open) {
      b.setAttribute('aria-expanded', 'true');
      var row = document.getElementById(b.getAttribute('data-cc-mbar-toggle'));
      if (row) row.hidden = false;
    }
  }, true);
})();

/* Phone filter bar hint: fade + arrow on the right while more chips are off-screen (filter-bar template). */
(function () {
  function sync(bar) {
    var tr = bar.querySelector('.cc-mbar__track'); if (!tr) return;
    var over = tr.scrollWidth > tr.clientWidth + 4;
    bar.classList.toggle('no-overflow', !over);
    bar.classList.toggle('is-end', over && tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 6);
  }
  function all() { document.querySelectorAll('.cc-mbar--hint').forEach(sync); }
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (t && t.classList && t.classList.contains('cc-mbar__track')) { var b = t.closest('.cc-mbar--hint'); if (b) sync(b); }
  }, true);
  window.addEventListener('resize', all);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  if (typeof MutationObserver === 'function') {
    var pend = false;
    new MutationObserver(function () { if (pend) return; pend = true; requestAnimationFrame(function () { pend = false; all(); }); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
